import type { LoginStrategy } from '../../../shared/types/routes/auth/v2';

/**
 * Human-readable labels for each login strategy, used in picker copy ("Sign in with …",
 * "Only available via …"). Covers the social providers and the SSO methods.
 */
export const STRATEGY_LABEL: Record<LoginStrategy, string> = {
  github: 'GitHub',
  gitlab: 'GitLab',
  bitbucket_cloud: 'Bitbucket',
  google: 'Google',
  saml: 'SAML',
  ldap: 'LDAP',
};
